module.exports = __webpack_public_path__ + "img/http-recap.bafa140c.svg";